import { render, staticRenderFns } from "./FormAttachment.vue?vue&type=template&id=64299210&"
import script from "./FormAttachment.vue?vue&type=script&lang=js&"
export * from "./FormAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64299210')) {
      api.createRecord('64299210', component.options)
    } else {
      api.reload('64299210', component.options)
    }
    module.hot.accept("./FormAttachment.vue?vue&type=template&id=64299210&", function () {
      api.rerender('64299210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/form/FormAttachment.vue"
export default component.exports